import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-center_alignment",
  "use": "icon-center_alignment-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-center_alignment\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M6,6H18V7.5H6Zm2,5h8V9.5H8ZM6,14.5H18V13H6ZM8,18h8V16.5H8Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol